import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export const notificationsService = {
  async list(params: { limit?: number; offset?: number; isRead?: boolean; type?: string } = {}) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.get(`${API_BASE_URL}/api/notifications`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
    return res.data as { notifications: any[]; unreadCount: number; pagination: any };
  },

  async markRead(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/notifications/${id}`, { isRead: true }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async markAllRead() {
    const token = localStorage.getItem('accessToken');
    const res = await axios.put(`${API_BASE_URL}/api/notifications/read-all`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  async delete(id: string) {
    const token = localStorage.getItem('accessToken');
    const res = await axios.delete(`${API_BASE_URL}/api/notifications/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
